import React, { useEffect, useState } from 'react'
import { ReactSVG } from 'react-svg'
import styled from "styled-components";
import { numberWithCommas } from '@/utils/index'
import { getPrice } from '@/utils/chainPrice'
import { useInterval } from '@/hooks/index'
import ArrowImg from '@/assets/svg/arrow.svg'
import { useAccount, useBalance, useContractReads } from "wagmi";
import { ethers } from "ethers";
import ActiveDebt from "@/components/ActiveDebt/Modal";
import TradeModal from "@/components/TradeModal/Modal";
import TradeModal2 from "@/components/TradeModal2/Modal";

import { jungleAbi, JungleCA, priceAbi, PRICECA } from '@/utils/abi'
import { toFixed } from '@/utils/index'
import TransferModal from "@/components/TransferModal/Modal";
import RepayModal from "@/components/RepayModal/Modal";

import BTCCImg from '@/assets/imgs/btc.png'
import ETHCImg from '@/assets/imgs/eth.png'
import LINKImg from '@/assets/imgs/link.png'

import KCharts from '@/components/KCharts/index'

export default function Market() {

  const { address } = useAccount();
 
  const tokenList = [{
    symbol:'jBTC 5x',
    desc:'Bitcoin',
    price:'19931.19',
    addr:'0x1b44F3514812d835EB1BDB0acB33d3fA3351Ee43'
  },{
    symbol:'jETH 5x',
    desc:'Etherum',
    price:'1413.14',
    addr:'0x1b44F3514812d835EB1BDB0acB33d3fA3351Ee43'
  },
  {
    symbol:'jLINK 5x',
    desc:'Chainlink',
    price:'6.14',
    addr:'0x1b44F3514812d835EB1BDB0acB33d3fA3351Ee43'
  },]

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [info, setInfo] = useState({});
  const [tokens, setTokens] = useState(tokenList);  
  const [balances, setBalances] = useState([0, 0])
  const [showList, setShowList] = useState([0, 0])
  
  const jungleContract = {
    address: JungleCA,
    abi: jungleAbi,
  }
  const priceContract = {
    address: PRICECA,
    abi: priceAbi,
  }

  let { data:personData } = useContractReads({
    contracts: [
      {
        ...jungleContract,
        functionName: 'debtBalanceOf',
        args: [0, address],
      },
      {
        ...jungleContract,
        functionName: 'holdingVal',
        args: [0, address],
      },      
      {
        ...jungleContract,
        functionName: 'synthBalanceOf',
        args: [0, 'jUSD', address],
      },
      {
        ...jungleContract,
        functionName: 'synthBalanceOf',
        args: [0,'jBTC', address],
      },
      {
        ...jungleContract,
        functionName: 'synthBalanceOf',
        args: [0, 'jETH', address],
      },
      {
        ...jungleContract,
        functionName: 'totalIssuedSynths',
        args:[0]
      },
      {
        ...jungleContract,
        functionName: 'jUSDSolidBalanceOf',
        args: [address]
      },
      {
        ...jungleContract,
        functionName: 'synthBalanceOf',
        args: [0, 'jLINK', address],
      },
    ],
    onError(error) {
      console.log('Error', error)
    },
    watch:true
  })
  personData = personData || []

  const { data:priceData } = useContractReads({
    contracts: [
      {
        ...priceContract,
        functionName: 'rateForCurrency',
        args: ['jBTC'],
      },
      {
        ...priceContract,
        functionName: 'rateForCurrency',
        args: ['jETH'],
      },
      {
        ...priceContract,
        functionName: 'rateForCurrency',
        args: ['jLINK'],
      },      
    ],
    onError(error) {
      console.log('Error', error)
    },
    watch:true
  })
  
  useEffect(() => {
    const [btcPrice, ethPrice, linkPrice] = (priceData || []).map(ethers.utils.formatEther)
    tokenList[0].price = Number(btcPrice).toFixed(2)
    tokenList[1].price = Number(ethPrice).toFixed(2)
    tokenList[2].price = Number(linkPrice).toFixed(2)
    setTokens([...tokenList])
  }, [priceData])

  const [
    activeDebt, 
    synthValue, 
    activeJUSDBalance, 
    jBTCBalance, 
    jETHBalance, 
    totalIssuedSynths,
    transferMax,
    jLINKBalance
  ] = (personData.filter(i => i).length && personData || Array(7).fill(0)).map(ethers.utils.formatEther)
  
  useEffect(() => {
    setBalances([jBTCBalance, jETHBalance, jLINKBalance])
  }, [jBTCBalance, jETHBalance, jLINKBalance])

  const transferError = ()=>{
    setIsOpen1(false)
    setIsOpen2(false)
    setIsOpen4(false)
    setIsOpen5(false)
  }

  const successCb = ()=>{
    setIsOpen1(false)
    setIsOpen2(false)
    setIsOpen4(false)
    setIsOpen5(false)
  }

  const selectToken = (e)=>{
    const dir = info.dir
    const coin = tokens.find(i => i.symbol === e.name)
    setInfo({ dir, coin })
  }
  const handleK = (idx)=>{
    
    if(!idx){
      if(showList[0] === 0){
        setShowList([1, 0, 0])
      }else{
        setShowList([0, 0, 0])
      }
      
    }else if(idx === 1){
      if(showList[1] === 0){
        setShowList([0, 1, 0])
      }else{
        setShowList([0, 0, 0])
      }

    }else if(idx === 2){
      if(showList[2] === 0){
        setShowList([0, 0, 1])
      }else{
        setShowList([0, 0, 0])
      }
    }
  }
  const handleTrade = (coin, dir,e)=>{   
    e.stopPropagation();
    e.preventDefault();
    if(dir === 'long') {
      setIsOpen4(true)
      setInfo({ dir, coin })      
    }else{
      setIsOpen5(true)
      setInfo({ dir, coin })      
    }
  }

  return (
    <MarketWrapper>
      <Comp>
        <div className='container'>
          <div className='p-title'></div>
          <div className='common-block stake-block'>
            <div className='top'>Debt Book 1 Total Debt: <span className='total-debt'>${numberWithCommas((+totalIssuedSynths).toFixed(2))}</span></div>
            <div className='line'></div>
            <div className='line2'></div>
            <div className='bot'>
              <div className='l'>
                <div className='l-t'>
                  <span>${(+activeDebt).toFixed(2)}</span>
                  {/* <ReactSVG src={ArrowImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/> */}
                </div>
                <div className='l-b'>My Active Debt</div>
              </div>
              <div className='c'>
                  <span className='spn-tx'>${numberWithCommas(synthValue)}</span>
                  <span className='fifth'>Synth Value</span>
              </div>
              <div className='r'>
                  <span className='gr'>{numberWithCommas(activeJUSDBalance)}</span>
                  <span className='fifth'>JUSD Balance (≈ ${numberWithCommas(activeJUSDBalance)})</span>                  
              </div>
            </div>
            <div className='buttons-group'>
              <div onClick={() => setIsOpen2(true)} className='button-item button-item-l'>Repay</div>
              <div onClick={() => setIsOpen1(true)} className='button-item button-item-r'>Transfer</div>
            </div>     
          </div>
          <div className='common-block token-block'>
            <div className='table'>
              <div className='title'>
                <div className='flex-1 flex-left'>Synth</div>
                <div className='flex-1'>Price</div>
                <div className='flex-1 rr-gr'>
                  <span className='fifth'>Wallet</span>         
                </div>
                <div className='flex-1 flex-right'>Action</div>
              </div>
              <div className='content'>                
                {
                  tokens.map( (item, idx) => <div onClick={()=> handleK(idx)} className='list-item' key={idx}>
                    <div className='info-top'>
                      <div className='info-top-top'>
                        <div className='flex-1 token-item'>
                          <img className="radius" src={!idx ? BTCCImg : (idx === 1 ? ETHCImg : LINKImg)} alt="" />
                          <div className='token'>
                            <div className='token-title'>{item.symbol}</div>
                            <div className='token-desc'>{item.desc}</div>
                          </div>
                        </div>
                        <div className='flex-1 money'>${item.price}</div>
                        <div className='flex-1 money t-money'>
                            <span className="balanc-t">{toFixed(balances[idx], 4) < 0.0001 && +balances[idx] ? '<0.0001' : toFixed(balances[idx])}</span>
                            <span className='balacne-m'>${numberWithCommas((item.price * balances[idx]))}</span>
                        </div>
                        <div className='flex-1 btns'>
                          {
                            (idx < 3) &&
                            <>
                              <div className='btn unstake' onClick={(e) => handleTrade(item, 'short', e)}>Sell</div>
                              <div className='btn stake' onClick={(e) => handleTrade(item, 'long', e)}>Buy</div>
                            </>
                          }
                        </div>
                      </div>
                    </div>
                    {
                        !!showList[idx] && <div className='k-charts'>
                         <KCharts symbol={!idx ? 'BTC' : (idx === 1 ? 'ETH' : 'LINK')} />
                       </div>            
                    }                    
                  </div> 
                )
              }
              </div>
            </div>
          </div>
        </div>
      </Comp>
      <TransferModal handleClose={() => setIsOpen1(false)} isOpen={isOpen1} jusdBalance={transferMax} transferError={transferError} successCb={successCb}/> 
      <RepayModal handleClose={() => setIsOpen2(false)} isOpen={isOpen2} jusdBalance={activeJUSDBalance} synthValue={synthValue} totalDebt={activeDebt} transferError={transferError} successCb={successCb}/> 
      <ActiveDebt handleClose={() => setIsOpen3(false)} isOpen={isOpen3}/> 
      <TradeModal handleClose={() => setIsOpen4(false)} selectToken={selectToken} isOpen={isOpen4} jusdBalance={activeJUSDBalance} transferError={transferError} successCb={successCb} info={info}/> 
      <TradeModal2 handleClose={() => setIsOpen5(false)} selectToken={selectToken} balance={balances} isOpen={isOpen5}  transferError={transferError} successCb={successCb} info={info}/> 
    </MarketWrapper>
  )
}

const MarketWrapper = styled.div`
`

const Comp = styled.div`
  .rr-gr{
    display: flex;
    align-items: center;    
    .fifth{
      padding-right: 4px;      
    }
  }
  .container{
    min-width: 1074px;
    margin-right: 10vw;
    .fifth-svg{
      cursor: pointer;                
      display: flex
    }
    .p-title{
      height: 30px;
    }
  }
  .common-block{
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
  }
  .stake-block{
    padding: 24px 34px 42px 31px;
    position: relative;
    .top {
      display: flex;
      justify-content: space-between;      
      font-weight: 400;
      font-size: 14px;      
      color: rgba(255, 255, 255, 0.6);
      line-height: 32px;
      .total-debt{
        font-weight: 600;
        font-size: 32px;
        line-height: 1;       
        color:#fff;
      }
    }
    
    .line {
      height:62px      
    }
    .line2{
      position: absolute;
      left: 0;
      top: 88px;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.1);
    }

    .bot{
      display: flex;
      justify-content: space-between;
      .l{
        display: flex;
        flex-direction: column;
        .l-t{
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 22px;          
          color: #F3F7F6;   
          span{
            font-size: 36px;
            line-height: 52px;
          }       
        }
        .l-b{
          color: rgba(255, 255, 255, 0.6);
          padding-top: 6px;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .c{
        display: flex;
        flex-direction: column;
        font-weight: 600;
        font-size: 22px;
        .spn-tx{
          font-size: 36px;
          line-height: 52px; 
        }
      }
      .fifth{
         font-size : 14px;
         font-weight: 400;
         color: rgba(255, 255, 255, 0.6);
      }
      .r{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        font-weight: 600;
        font-size: 22px;
        .gr{
          font-size: 36px;
          line-height: 52px; 
        }
        .r-gr{
            display: flex;
            align-items: center;
          }
          .total-balance{
            font-size: 14px;
            padding-top: 12px;
            line-height: 17px;
          }
      }
    }
    .buttons-group{
      display: flex;
      justify-content: flex-end;
      padding-top: 37px;
      font-weight: 600;
      .button-item{
        width: 130px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        color: #fff;
        border-radius: 8px;
        cursor: pointer;
      }
      .button-item-l{
        background: #FF8A00;
        margin-right:40px;
        &:hover{
          background:#B36100; 
        }
      }
      .button-item-r{
        background: #32DE86;
        &:hover{
          background:#239B5E; 
        }        
      }
    }
  }

  .token-block{
    margin-top:16px;
    padding: 24px 0 8px 0;
    margin-bottom: 30px;
  }
  .table{    
    font-size: 16px;
    color: #F3F7F6;
    .title{
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 1;
      padding: 0 43px 10px 30px;
      font-weight: 600;
      line-height: 20px;      
      color: rgba(255, 255, 255, 0.6); 
      .flex-1{
        flex: 1;
        display: flex;
        justify-content: center;
      }      
      .flex-left{
        justify-content: flex-start;
      }
      .flex-right{
        justify-content: flex-end;
      }
    }
    .content{

    }
    .list-item{
      line-height: 69px;
      cursor: pointer;
      
      & + .list-item{
        border-top:1px solid rgba(255, 255, 255, 0.1);
      }
      .info-top{
        .info-top-top{
          padding-left:30px;
      padding-right:34px;
          display: flex;
          justify-content: space-between;
          flex: 1;
        }
        &:hover{
          background: rgba(255, 255, 255, 0.1);
        }
      }
      .flex-1{
        flex: 1;
      }
      .t-money{
        display: flex;
        align-items: center;
      }
      .balanc-t{
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;       
      }
      .balacne-m{
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.6);
        padding-left: 9px;
      }
      .token-item{
        display: flex;
        align-items: center;
        .radius{
          width: 32px;
          height: 32px;
          border-radius:50%;
          background: #D9D9D9;
          margin-right:12px;
        }
      }
      .token{
        display: flex;
        flex-direction: column;
        line-height: 1;
        .token-title{
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
        }
        .token-desc{
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
      .money{          
        display: flex;
          justify-content: center;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
        }
      .btns{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .btn{
          height: 33px;
          width: 61px;
          line-height: 33px;
          text-align: center;
          font-weight: 600;
          font-size: 16px;
          color: #fff;
          border-radius: 8px;
        }
        .stake{
          color: #fff;
          background: #32DE86;
          &:hover{
            background:#239B5E; 
          }
        }
        .unstake{
          width: 61px;
          background: #FF8A00;
          color: #fff;
          margin-right: 21px;
          &:hover{
            background:#B36100; 
          }
        }

      }
    }
  }
`